import Routes from "@/router/routes";

export default {
    /**
     * Returns array of route roles
     *
     * @param {string} route_name
     * @returns {(Array|null)}
     */
    getRoles(route_name) {
        let route = _.find(Routes, {name: route_name});
        return _.get(route, 'meta.roles', null);
    }
}
